import React from "react"
import {Divider, Grid, Segment} from "semantic-ui-react"
import {resetPasswordURL} from "../../shared/urls/clientapi";
import AllRightsReserved from "../../shared/components/AllRightsReserved";
import CompanyLogo from "../../shared/components/CompanyLogo";
import ChangePassword from "../ChangePassword";
import ReactGA from 'react-ga';
import { trackPageView } from '../../shared/tracking';

export default class PasswordReset extends React.Component {
  constructor(props) {
    super(props);

    ReactGA.set({ page: 'passwordreset' });
    ReactGA.pageview('passwordreset');
    trackPageView('/passwordreset');
  }

  render() {
    return (
      <div className='form'>
        <style>{`
          body > div,
          body > div > div,
          body > div > div > div.form {
            height: 100%;
            background-color: #f2f2f2;
          }
        `}</style>
        <Grid textAlign='center' style={{ height: '100%' }} verticalAlign='middle'>
          <Grid.Column style={{ maxWidth: 450 }}>
            <CompanyLogo linkTo='/login'/>            
            <Segment>
              <ChangePassword
                header='Create a new password'
                showTerms={true}
                redirectOn={true}
                url={resetPasswordURL}
                history={this.props.history}
                match={this.props.match}
              />
            </Segment>  
            <Divider hidden />
            <AllRightsReserved />
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/PasswordReset/index.js